import { getRechargeDayApi } from '@/api/pay';
import { getMachineTypeListApi } from '@/api/machine';

const options = {
  namespaced: true,
  state: {
    wrapperShow: false, /** 最外层的隐藏显示 */
    orderSn: {
      value: '',
    },
    statusMap: {
      deliveryStatus: '',
      orderStatus: '',
    },
    tradeNo: {
      value: '',
    },
    vip: {
      value: null,
      cardNo: null,
      list: ['普通卡', '全场卡'],
      show: false,
    },
    status: { /** 机器状态 */
      value: {},
      list: [{ status: null, name: '全部' }, { status: 0, name: '正常' }, { status: 1, name: '停用' }],
      show: false,
    },
    threeMonth: {
      value: null,
      list: [],
      show: false,
    },
    location: { /** 选择地区 */
      value: { num: null, name: '全部地区', list: [null, null, null, null] }, /** 导航栏的默认地区  编号 当前选择名字 总选择数组 */
      choose: { /** 记录一步步选择的城市 */
        province: { num: null, name: null },
        city: { num: null, name: '请选择城市' },
        country: { num: null, name: '请选择县' },
        street: { num: null, name: '请选择镇' },
      },
      BakChoose: { /** 储存初始状态的choose 用于清除已选择的地区用 */
        province: { num: null, name: null },
        city: { num: null, name: '请选择城市' },
        country: { num: null, name: '请选择县' },
        street: { num: null, name: '请选择镇' },
      },
      provinceList: [
        { initial: 'A', list: [{ num: 340000, name: '安徽省' }, { num: 820000, name: '澳门特别行政区' }] },
        { initial: 'B', list: [{ num: 110000, name: '北京' }] },
        { initial: 'C', list: [{ num: 500000, name: '重庆' }] },
        { initial: 'D', list: [{ num: 900000, name: '钓鱼岛' }] },
        { initial: 'F', list: [{ num: 350000, name: '福建省' }] },
        { initial: 'G', list: [{ num: 440000, name: '广东省' }, { num: 450000, name: '广西壮族自治区' }, { num: 520000, name: '贵州省' }, { num: 620000, name: '甘肃省' }] },
        { initial: 'H', list: [{ num: 130000, name: '河北省' }, { num: 230000, name: '黑龙江省' }, { num: 410000, name: '河南省' }, { num: 420000, name: '湖北省' }, { num: 430000, name: '湖南省' }, { num: 460000, name: '海南省' }] },
        { initial: 'J', list: [{ num: 220000, name: '吉林省' }, { num: 320000, name: '江苏省' }, { num: 360000, name: '江西省' }] },
        { initial: 'L', list: [{ num: 210000, name: '辽宁省' }] },
        { initial: 'N', list: [{ num: 640000, name: '宁夏回族自治区' }, { num: 150000, name: '内蒙古自治区' }] },
        { initial: 'Q', list: [{ num: 630000, name: '青海省' }] },
        { initial: 'S', list: [{ num: 140000, name: '山西省' }, { num: 310000, name: '上海' }, { num: 370000, name: '山东省' }, { num: 510000, name: '四川省' }, { num: 610000, name: '陕西省' }] },
        { initial: 'T', list: [{ num: 120000, name: '天津' }, { num: 710000, name: '台湾' }] },
        { initial: 'X', list: [{ num: 650000, name: '新疆维吾尔自治区' }, { num: 810000, name: '香港特别行政区' }, { num: 540000, name: '西藏自治区' }] },
        { initial: 'Y', list: [{ num: 530000, name: '云南省' }] },
        { initial: 'Z', list: [{ num: 330000, name: '浙江省' }] },
      ],
      cityList: [{}],
      countryList: [{}],
      streetList: [{}],
      hot: [ /** 热门城市 */
        {
          name: '北京',
          province: { num: '100000', name: '北京' },
          city: { num: '110000', name: '北京' },
        }, {
          name: '上海',
          province: { num: '310000', name: '上海' },
          city: { num: '310100', name: '上海' },
        }, {
          name: '广州',
          province: { num: '440100', name: '广州' },
        }, {
          name: '深圳',
          province: { num: '440000', name: '广东' },
          city: { num: '440300', name: '深圳' },
        }, {
          name: '杭州',
          province: { num: '330000', name: '浙江' },
          city: { num: '330100', name: '杭州' },
        }, {
          name: '南京',
          province: { num: '320000', name: '江苏' },
          city: { num: '320100', name: '南京' },
        }, {
          name: '苏州',
          province: { num: '320000', name: '江苏' },
          city: { num: '320500', name: '苏州' },
        }, {
          name: '天津',
          province: { num: '120000', name: '天津' },
          city: { num: '120100', name: '天津' },
        }, {
          name: '武汉',
          province: { num: '420000', name: '湖北' },
          city: { num: '420100', name: '武汉' },
        }, {
          name: '长沙',
          province: { num: '430000', name: '湖南' },
          city: { num: '430100', name: '长沙' },
        }, {
          name: '重庆',
          province: { num: '500000', name: '重庆' },
          city: { num: '500100', name: '重庆' },
        }, {
          name: '成都',
          province: { num: '510000', name: '四川' },
          city: { num: '510100', name: '成都' },
        },
      ],
      show: false,
    },
    machine: {
      value: '全部设备',
      list: [],
      show: false,
    },
    activity: {
      value: '全部活动类型',
      list: [],
      show: false,
    },
    date: { /** 日期 */
      from: null,
      to: null,
      set: null, /** 当前要操作from 还是to */
      show: false,
    },
    discount: { /** 优惠 */
      value: {},
      list: [],
      show: false,
    },
    payment: { /** 付款方式 */
      value: '支付宝',
      index: 1,
    },
    operator: { /** 运营商 */
      value: {},
      list: [],
      show: false,
    },
    allocation: { /** 经销商 */
      value: {},
      list: [],
      show: false,
    },
    machineType: { /** 机器类型 */
      value: null,
      list: [],
      show: false,
    },
    agreementType: { /** 商品类型 */
      value: { value: 1, text: 'YPL' },
      list: [{ value: 1, text: 'YPL' }, { value: 5, text: 'LYY' }],
      show: false,
    },
    temperatureModel: { /** 温度模式 */
      value: { value: 0, text: '常温' },
      list: [{ value: 0, text: '常温' }, { value: 1, text: '制冷' }, { value: 2, text: '制热' }],
      show: false,
    },
    temperatureModelLeft: { /** 温度模式 */
      value: { value: 0, text: '常温' },
      list: [{ value: 0, text: '常温' }, { value: 1, text: '制冷' }, { value: 2, text: '制热' }],
      show: false,
    },
    temperatureModelRight: { /** 温度模式 */
      value: { value: 0, text: '常温' },
      list: [{ value: 0, text: '常温' }, { value: 1, text: '制冷' }, { value: 2, text: '制热' }],
      show: false,
    },
    machineShelfType: { /** 货道类型 */
      value: { text: '三线电机', value: 1 },
      list: [{ text: '三线电机', value: 1 }, { text: '二线电机电子锁', value: 2 }, { text: '60三线电机+40电子锁', value: 3 }, { text: '60两线电机+40电子锁', value: 4}],
      show: false,
    },
    openShoppingCart: { /** 支付设置 */
      value: {},
      list: [{ value: 1, text: '购物车支付' }, { value: 0, text: '普通支付' }],
      show: false,
    },
    goodsType: { /** 商品类型 */
      value: {},
      list: [],
      show: false,
    },
    // copyMachine:{ /**拷贝机器 */
    //   value:null,
    //   valueTrue:null,
    //   list:[],
    //   show:false
    // },
    renew: { /** 续费 */
      value: '1月/30天',
      list: ['1月/30天', '2月/60天', '3月/90天', '4月/120天', '5月/150天', '6月/180天', '7月/210天', '8月/240天', '9月/270天', '1年/360天', '2年/720天'],
      show: false,
    },
    withdraw: { /** 提现筛选 */
      value: { num: null },
      list: [{ num: null, text: '全部' }, { num: 0, text: '提现中' }, { num: 1, text: '提现成功' }, { num: 2, text: '提现失败' }],
      show: false,
    },
    deliveryDetails: { /** 出货记录选择 */
      value: '非现金',
      index: 0,
    },
  },
  mutations: {
    clearAll(state) {
      state.location.value = { num: null, name: '全部地区', list: [null, null, null, null] };
      state.location.choose = {
        province: { num: null, name: null },
        city: { num: null, name: '请选择城市' },
        country: { num: null, name: '请选择县' },
        street: { num: null, name: '请选择镇' },
      };
      state.machine.value = '全部设备';
      state.activity.value = '全部活动类型';

      const year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      month = month > 9 ? month : `0${month}`;
      let date = new Date().getDate();
      date = date > 9 ? date : `0${date}`;
      const time = `${year}-${month}-${date}`;

      state.date.from = time;
      state.date.to = time;

      state.discount.value = {};
      state.allocation.value = {};
      state.operator.value = {};
      state.machineType.value = null;
      state.goodsType.value = {};
      state.agreementType.value = { value: 1, text: 'YPL' };
      state.temperatureModel.value = { value: 0, text: '常温' };
      state.temperatureModelLeft.value = { value: 0, text: '常温' };
      state.temperatureModelRight.value = { value: 0, text: '常温' };
      state.machineShelfType.value = { text: '三线电机', value: 1 };
      state.openShoppingCart.value = {};
    },
    alertShow(state, { name, status }) {
      state.wrapperShow = status === false ? false : !state.wrapperShow;
      state.threeMonth.show = false;
      state.location.show = false;
      state.machine.show = false; /** 关闭所有小窗口 */
      state.activity.show = false; /** 关闭所有小窗口 */
      state.date.show = false;
      state.discount.show = false;
      state.operator.show = false;
      state.allocation.show = false;
      state.machineType.show = false;
      state.goodsType.show = false;
      // state.copyMachine.show = false
      state.renew.show = false;
      state.withdraw.show = false;
      state.status.show = false;
      state.vip.show = false;
      state.agreementType.show = false;
      state.temperatureModel.show = false;
      state.temperatureModelLeft.show = false;
      state.temperatureModelRight.show = false;
      state.machineShelfType.show = false;
      state.openShoppingCart.show = false;
      if (typeof name === 'string') {
        state[name].show = true; /** 如果传了名字 折让改名字的窗口打开 */
      }
    },
    clearTargetValue(state, info) { /** 清除指定值 传对象名 对象的属性名 */
      state[info[0]][info[1]] = null;
    },
    lastThreeMonth(state) { /** 计算 前3个月的月份 */
      state.threeMonth.list = [];/** 先清空数组 */
      const month = new Date().getMonth() - 1;
      for (let i = 0; i < 3; i++) {
        let va = month + i;
        if (va == -1) {
          va = 11;
        } else if (va == 0) {
          va = 12;
        }
        va = va >= 10 ? String(va) : `0${va}`;
        state.threeMonth.list.push(va); /** 设置可以选择的月份 */
        state.threeMonth.value = state.threeMonth.list[state.threeMonth.list.length - 1]; /** 默认选择当前月 */
      }
    },
    chooseLastThreeMonth(state, index) { /** 改变选择的月份 */
      const val = state.threeMonth.list[index];
      state.threeMonth.value = val || '选择月份'; /** 改变值  为第几个数组的内容 */
    },
    setMachineVal(state, list) { /** 设置可选的机器列表 */
      state.machine.list = [].concat(list);
    },
    setOrderNum(state, orderSn) {
      state.orderSn.value = orderSn;
    },
    setTradeNo(state, tradeNo) {
      state.tradeNo.value = tradeNo;
    },
    setStatusMap(state, { name, value }) {
      state.statusMap[name] = value;
    },
    chooseMachine(state, index) { /** 选择机器 */
      const val = state.machine.list[index];
      state.machine.value = val || '选择机器';
    },
    setActivityVal(state, list) { /** 设置可选的活动类型列表 */
      state.activity.list = [].concat(list);
    },
    chooseActivity(state, index) { /** 选择活动类型 */
      const val = state.activity.list[index];
      state.activity.value = val || '选择活动类型';
    },
    copyMachine(state) { /** 拷贝机器 */
      state.copyMachine.valueTrue = JSON.parse(JSON.stringify(state.copyMachine.value));
    },
    // setCopyMachineList(state,list){ /**取得拷贝机器的内容 */
    //   state.copyMachine.list.splice(0,state.copyMachine.list.length) /**清空数组 */
    //   state.copyMachine.list = [].concat(list) /**赋值数组 */
    // },
    setDate(state, date) { /** 设置日期 */
      if (date) { /** 传了日期 就设置为传的日期iu */
        if (date.from) {
          state.date.from = date.from;
        }
        if (date.to) {
          state.date.to = date.to;
        }
      } else {
        const date = new Date();
        const year = date.getYear() + 1900;
        let month = date.getMonth() + 1;
        month = month > 9 ? month : `0${month}`;
        let day = date.getDate();
        day = day > 9 ? day : `0${day}`;
        const res = `${year}-${month}-${day}`;
        state.date.from = res;
        state.date.to = res; /** 获取当天日期 将起止日期都设为当天 */
      }
    },
    setDateSet(state, name) { /** 设置 设置日期的  当前要操作的哪个 */
      state.date.set = name;
    },
    choosePayment(state, info) { /** 设置收款方式的索引 */
      state.payment.value = info[0];
      state.payment.index = info[1];
    },
    chooseDeliveryDetails(state, info) { /** 设置出货明细的索引 */
      state.deliveryDetails.value = info[0];
      state.deliveryDetails.index = info[1];
    },
    setCommon(state, info) { /** 设置通用 */
      state[info[0]].value = info[1];
      /** 设置通用  状态管理的 传进来 名字的那个对象的value 等于传进来的那个值 */
    },
    setCommonList(state, info) { /** 设置通用的列表 运营商 机器内容等 */
      state[info.name].list = [...info.list];
    },
    chooseLocation(state, info) { /** 选择地址 */
      const el = state.location.choose[info[0]]; /** 取得对哪个设置 */
      el.name = info[1]; /** 设置地区 */
      el.num = info[2]; /** 设置编号 */

      let start = null;
      switch (info[0]) {
      case 'province':
        start = 0;
        break;
      case 'city':
        start = 1;
        break;
      case 'country':
        start = 2;
        break;
      case 'street':
        start = 3;
        break;
      default:
        start = null;
      } /** 判断替换数组第几个内容 */

      const arr = state.location.value.list; /** 取得数组 */
      arr.splice(start, 1, info[1]); /** 删除第几个开始的1个内容 并替换成传件来的地区名字 */
      const val = arr.join(' ');
      state.location.value.num = info[2]; /** 设置待传值的地区 */
      state.location.value.name = val; /** 设置显示的名字  将数组转化为字符串 */
    },
    chooseHotLocation(state, info) {
      const el = state.location.choose;
      const ele = state.location.value;
      if (info.province) { /** 检测是否有指定的地名 */
        el.province = info.province; /** 将一步步选择城市的数据替换为指定的数据 */
        ele.num = info.province.num; /** 将最终传值的编号赋值为指定的编号 */
        ele.list[0] = info.province.name; /** 将自重传值的名字赋值为指定的名字 */
      }

      if (info.city) {
        el.city = info.city;
        ele.num = info.city.num;
        ele.list[1] = info.city.name;
      }
      if (info.country) {
        el.country = info.country;
        ele.num = info.country.num;
        ele.list[2] = info.country.name;
      }
      if (info.street) {
        el.street = info.street;
        ele.num = info.street.num;
        ele.list[3] = info.street.name;
      }

      ele.name = ele.list.join(' '); /** 设置显示的名字 */
    },
    clearLocation(state, name) { /** 清除选择的地区 */
      const el = state.location.choose;
      const ele = state.location.BakChoose;
      const elv = state.location.value;
      let change = false; /** 检测什么时候开始 检测到就变成true */

      let num = -1;
      for (const i in el) {
        num++;
        if (name === i) { /** 从头开始循环 */
          change = true; /** 如果设置的是这个名字 则开启设置 */
        }

        if (!change) { /** 如果没开启 则重新给传值的num赋值 */
          elv.num = el[i].num;
        } else { /** 如果设置被开启了 则往后的每个都等于备注的内容 */
          el[i] = JSON.parse(JSON.stringify(ele[i]));

          elv.list.splice(num, 1, null); /** 开始后清除数组的内容 */
        }
      }

      elv.name = !elv.list[0] ? '全部地区' : elv.list.join(' ');/** 设置名字 */
      if (name === 'province') { elv.num = null; } else if (name === 'city') { elv.num = el.province.num; } else if (name === 'country') { elv.num = el.city.num; } else if (name === 'street') { elv.num = el.country.num; }
    },
    setRenew(state, renew) {
      state.renew = renew;
    },
    setMachineTypeList(state, data) {
      state.machineType.list = data;
    },
  },
  actions: {
    clearAllGo(content) {
      return content.commit('clearAll');
    },
    alertShowGo(content, { name, status }) {
      content.commit('alertShow', { name, status });
    },
    clearTargetValueGo(content, info) {
      content.commit('clearTargetValue', info);
    },
    lastThreeMonthGo(content) {
      content.commit('lastThreeMonth');
    },
    chooseLastThreeMonthGo(content, index) {
      content.commit('chooseLastThreeMonth', index);
    },
    setMachineValGo(content, list) {
      content.commit('setMachineVal', list);
    },
    chooseMachineGo(content, index) {
      content.commit('chooseMachine', index);
    },
    setActivityValGo(content, list) {
      content.commit('setActivityVal', list);
    },
    chooseActivityGo(content, index) {
      content.commit('chooseActivity', index);
    },
    // copyMachineGo(content){
    //   return content.commit('copyMachine')
    // },
    setCopyMachineListGo(content, list) {
      content.commit('setCopyMachineList', list);
    },
    setDateGo(content, date) {
      return content.commit('setDate', date);
    },
    setDateSetGo(content, name) {
      content.commit('setDateSet', name);
    },
    choosePaymentGo(content, ...info) {
      content.commit('choosePayment', ...info);
    },
    chooseDeliveryDetailsGo(content, ...info) {
      content.commit('chooseDeliveryDetails', ...info);
    },
    setCommonGo(content, ...info) {
      content.commit('setCommon', ...info);
    },
    setCommonListGo(content, info) {
      return content.commit('setCommonList', info);
    },
    chooseLocationGo(content, info) {
      content.commit('chooseLocation', info);
    },
    clearLocationGo(content, name) {
      content.commit('clearLocation', name);
    },
    chooseHotLocationGo(content, info) {
      return content.commit('chooseHotLocation', info);
    },
    setOrderNum(content, orderSn) {
      return content.commit('setOrderNum', orderSn);
    },
    setTradeNo(content, tradeNo) {
      return content.commit('setTradeNo', tradeNo);
    },
    setStatusMap(content, data) {
      return content.commit('setStatusMap', data);
    },
    async getRechargeDay(content) {
      const res = await getRechargeDayApi();
      const renew = {};
      if (res && res.status) {
        renew.show = false;
        renew.list = [];
        res.data.map(item => {
          let num = 0;
          if (item < 360) {
            num = item / 30;
            renew.list.push(`${num}月/${item}天`);
          } else {
            num = item / 360;
            renew.list.push(`${num}年/${item}天`);
          }
        });
        renew.value = renew.list[0];
      }
      content.commit('setRenew', renew);
    },
    async getMachineTypeList(content) {
      const res = await getMachineTypeListApi();
      const arr = [];
      if (res && res.status) {
        for (const key in res.data) {
          arr.push(res.data[key]);
        }
      }
      content.commit('setMachineTypeList', arr);
    },
  },
};

export default options;



// WEBPACK FOOTER //
// ./src/store/modules/options.js